/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCopyToCompany.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-copy-to-company";

export class AutogenModelEdiCopyToCompany<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCopyToCompanyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCopyToCompany extends ModelRow<RowEdiCopyToCompanyFields> {
	constructor(values?: Partial<RowEdiCopyToCompanyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCopyToCompanyFields {
	alt_partner_id: string;
	company_id: string;
	destination_company: string;
	direction: string;
	id: string;
	partner_id: string;
	purpose: string;
	transaction_set: string;
	version: string;
}

